import React from "react";
import ReactDOM from "react-dom";
import Main from "./containers";

import "../node_modules/jquery/dist/jquery.min.js"
import "./css/index.css";

ReactDOM.render(
  <Main/>, 
  document.getElementById("root")
);
